

















import { Component, Vue, Emit, Prop } from 'vue-property-decorator'

@Component
export default class SelectPhoto extends Vue {

  @Prop({ default: '' })
  value!: string

  isUploading:boolean = false

  get previewStyle(): any {
    if (this.value) {
      return { 'background-image': `url(${this.value})` }
    }
    return {}
  }

  public get isDataUrl(): boolean {
    return /^data/.test(this.value)
  }

  private beforeSelectFile() {
    // clear the value before select
    (this.$refs.file as any).value = ''
  }

  private fileChanged(event: any) {
    console.log('Image changed ... ', event)
    this.fetchImage(event.target.files[0])
      .then(this.input.bind(this))
  }

  private fetchImage(file: File): Promise<string> {
    console.log('Fetch Image', file)
    // Resize Image with Canvas
    const resizeImage = (dataUrl: any) => new Promise((resolve: (val: string) => void, reject) => {
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')!

        // Cap max dimension to 600
        if (img.height > img.width) {
          canvas.height = 600
          canvas.width = canvas.height * img.width / img.height
        } else {
          canvas.width = 600
          canvas.height = canvas.width * img.height / img.width
        }

        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height)

        resolve(canvas.toDataURL())
      }
      // begin loading
      img.src = dataUrl
    })

    return new Promise((resolve, reject) => {
      const fr = new FileReader()
      fr.onload = (e: any) => {
        resolve(e.target.result)
      }
      console.log('Start loading file: ', (this.$refs.file as any).files)
      fr.readAsDataURL(file)
    })
    .then(resizeImage)
  }

  private static performRotateOnImage(src: String, angle: number): Promise<string> {
    console.log(`Begin rotate image by loading ${angle}`, src)
    const rotateImage = (dataUrl: any) => new Promise((resolve: (val: string) => void, reject) => {
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')!

        // Create canvs
        canvas.width = img.height
        canvas.height = img.width

        // Rotate
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        ctx.translate(img.height/2, img.width/2)
        ctx.rotate(angle * (22/7) / 180)
        ctx.drawImage(img, -img.width/2, -img.height/2)

        resolve(canvas.toDataURL())
      }
      // begin loading
      img.src = dataUrl
      img.crossOrigin = 'anonymous'
    })
    return rotateImage(src)
  }

  private async rotateCW() {
    if (!this.value) {
      return;
    }
    this.input(await SelectPhoto.performRotateOnImage(this.value, +90))
  }

  private async rotateCCW() {
    if (!this.value) {
      return;
    }
    this.input(await SelectPhoto.performRotateOnImage(this.value, 270))
  }

  @Emit('input')
  private input(url: string) { }
}
